import React, { useEffect, useState } from "react";
import { Calendar } from "react-big-calendar";
import { ScheduleToolbar } from "./ScheduleToolbar";
import axiosInstance from "../../../utils/axiosConfig";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/es";

export const ScheduleCalendarView = ({
  localizer,
  schedules,
  handleEventSelect,
  currentUser,
  setSelectedSchedule,
  fetchSchedules,
  setFormData,
  setModalIsOpen,
  eventPropGetter,
}) => {
  const { t, i18n } = useTranslation();
  const [holidays, setHolidays] = useState([]);
  const currentYear = new Date().getFullYear();
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const getHolidays = async () => {
      try {
        const { data } = await axiosInstance.get(
          `https://date.nager.at/api/v3/publicholidays/${currentYear}/CO`
        );

        const formattedHolidays = data.map((holiday) => {
          const originalDate = new Date(holiday.date);
          originalDate.setDate(originalDate.getDate() + 1);

          return {
            title: `🎉 ${holiday.localName}`,
            start: originalDate,
            end: originalDate,
            allDay: true,
            isHoliday: true,
          };
        });

        setHolidays(formattedHolidays);
      } catch (error) {
        console.log(t("errorFetchingHolidays"), error);
        setHolidays([]);
      }
    };

    getHolidays();
  }, [currentYear, t]);

  const allEvents = [...schedules, ...holidays];

  const customEventPropGetter = (event) => {
    if (event.isHoliday) {
      return {
        style: {
          backgroundColor: "#FF9999",
          color: "#000",
          border: "none",
          fontWeight: "bold",
        },
      };
    }
    return eventPropGetter(event);
  };

  useEffect(() => {
    const month = moment(currentDate).month() + 1;
    const year = moment(currentDate).year();
    fetchSchedules({ month, year });
  }, [currentDate]);

  return (
    <>
      <Calendar
        culture={i18n.language}
        localizer={localizer}
        events={allEvents}
        date={currentDate}
        defaultView="month"
        views={["month", "week", "day"]}
        onSelectEvent={handleEventSelect}
        onNavigate={(newDate) => {
          setCurrentDate(newDate); // ← control total del mes visible
        }}
        style={{ height: 700 }}
        startAccessor="start"
        endAccessor="end"
        onRangeChange={(range) => {
          let start = Array.isArray(range) ? range[0] : range.start;
          let end = Array.isArray(range) ? range[range.length - 1] : range.end;

          const middle = new Date((start.getTime() + end.getTime()) / 2);
          setCurrentDate(middle); // ← mantiene sincronía
        }}
        components={{
          toolbar: (props) => (
            <ScheduleToolbar
              props={props}
              currentUser={currentUser}
              onNewSchedule={() => {
                setSelectedSchedule(null);
                setFormData({
                  start_time: "",
                  end_time: "",
                  description: "",
                  user_id: null,
                  client_id: null,
                  service_type: "",
                });
                setModalIsOpen(true);
              }}
            />
          ),
        }}
        eventPropGetter={customEventPropGetter}
      />
    </>
  );
};
